import { DATE_PIPE_DEFAULT_OPTIONS } from '@angular/common';
import { HTTP_INTERCEPTORS, HttpClientModule } from "@angular/common/http";
import { AuthErrorInterceptor } from "./domain/service/api-key/auth-error.interceptor";
import {
  CUSTOM_ELEMENTS_SCHEMA,
  ErrorHandler,
  NgModule,
  importProvidersFrom,
  provideZoneChangeDetection,
} from "@angular/core";
import { ClientLogInterceptor } from "./domain/service/client-log/client-log.interceptor";
import { GlobalErrorHandler } from "./domain/service/client-log/global-error-handler";
import { provideNativeDateAdapter } from "@angular/material/core";
import { MatIconModule, MatIconRegistry } from "@angular/material/icon";
import { BrowserModule, DomSanitizer } from "@angular/platform-browser";
import { provideAnimationsAsync } from "@angular/platform-browser/animations/async";
import { CodeInputModule } from "angular-code-input";
import { AppRoutingModule } from "./app-routing.module";
import { AppComponent } from "./app.component";
import { MaterialModule } from "./material/material.module";
import { RestorePasswordModule } from "./pages/account/restore-password/restore-password.module";
import { BankOwnerInformationModule } from "./pages/bank/bankink-owner-infromation.module";
import { MyProfileModule } from "./pages/myprofile/myprofile.module";
import { PropertyModule } from "./pages/properties/properties.module";
import { PropertyListModule } from "./pages/propertylist/propertylist.module";
import { RegisterOwnerModule } from "./pages/register-owner/register-owner.module";
import { RegisterStepperModule } from "./pages/register/register-stepper.module";
import { SecurityModule } from "./security/security.module";
import { ConfirmDialogComponent } from "./shared/confirm-dialog/confirm-dialog.component";
import { SharedModule } from "./shared/share.module";
import { ProfileModule } from "./pages/profile/profile.module";
import { Icons } from "./enums/icons-enums";
import { TaxCertificateNumberDirective } from "./directives/tax-number-input.directive";
import { ApiKeyInterceptor } from './domain/service/api-key/api-key.interceptor';
import { DatePipe } from "@angular/common";
import { PaymentsModule } from "./pages/payments/payments.module";
import { NATIVE_INIT_PROVIDER } from "./core/native/native-init";

@NgModule({
  declarations: [AppComponent, ConfirmDialogComponent,],
  imports: [
    BrowserModule,
    AppRoutingModule,
    SharedModule,
    BankOwnerInformationModule,
    PropertyListModule,
    RegisterOwnerModule,
    MyProfileModule,
    SecurityModule,
    RestorePasswordModule,
    RegisterStepperModule,
    PropertyModule,
    MaterialModule,
    MatIconModule,
    ProfileModule,
    PaymentsModule,
    TaxCertificateNumberDirective,
    CodeInputModule.forRoot({
      codeLength: 4,
      isCharsCode: true,
      code: "----",
    }),
  ],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
  providers: [
    // Todd QA round 2: every date in the portal renders as US mm/dd/yyyy.
    { provide: DATE_PIPE_DEFAULT_OPTIONS, useValue: { dateFormat: 'MM/dd/yyyy' } },
    provideAnimationsAsync(),
    importProvidersFrom(HttpClientModule),
    provideNativeDateAdapter(),
    {
      provide: HTTP_INTERCEPTORS,
      useClass: ApiKeyInterceptor,
      multi: true
    },
    { provide: HTTP_INTERCEPTORS, useClass: AuthErrorInterceptor, multi: true },
    {
      provide: HTTP_INTERCEPTORS,
      useClass: ClientLogInterceptor,
      multi: true
    },
    {
      provide: ErrorHandler,
      useClass: GlobalErrorHandler
    },
    NATIVE_INIT_PROVIDER,
    DatePipe
  ],
  bootstrap: [AppComponent],
})
export class AppModule {
  constructor(
    private matIconRegistry: MatIconRegistry,
    private domSanitzer: DomSanitizer
  ) {
    this.registerSVGIcon()
  }

  registerSVGIcon() {
    Object.values(Icons).forEach(icon => {
      this.matIconRegistry.addSvgIcon(
        icon,
        this.domSanitzer.bypassSecurityTrustResourceUrl(`/assets/icons/${icon}.svg`)
      );
    });
  }
}
